import { TestedPartyMapping } from "../models/tested-party-mapping/TestedPartyMapping";

export enum CompanyCodeType {
    PROVIDER = 'PROVIDER',
    TESTED_PARTY = 'TESTED_PARTY',
}

/**
 * Filters CLI numbers from mappings by tested party company code.
 * Returns distinct CLI numbers matching the given tested party code.
 */
export function getClisByTestedPartyCode(mappings: TestedPartyMapping[], testedPartyCode: string): string[] {
    const clis = new Set<string>();
    for (const mapping of mappings) {
        if (mapping.testedPartyCompanyCode === testedPartyCode && mapping.cliNumber) {
            clis.add(mapping.cliNumber);
        }
    }
    return Array.from(clis);
}

/**
 * Looks up the firstPartyCompanyCode for a given CLI from tested party mappings.
 * Returns undefined if no matching CLI is found.
 */
export function getProviderCodeForCli(mappings: TestedPartyMapping[], cliNumber: string): string | undefined {
    const mapping = mappings.find(m => m.cliNumber === cliNumber);
    return mapping?.firstPartyCompanyCode;
}
